// src/uicomponents/DateField.jsx
import React from "react";
import { useField } from "formik";
import { TextField } from "@mui/material";

const DateField = ({ label, ...props }) => {
  const [field, meta] = useField(props);

  return (
    <TextField
      sx={{ maxWidth: "60vw" }}
      type="date"
      label={label}
      InputLabelProps={{ shrink: true }}
      {...field}
      {...props}
      error={Boolean(meta.touched && meta.error)}
      helperText={meta.touched && meta.error}
    />
  );
};

export default DateField;
